import React from 'react'
import { Link } from 'react-router-dom'

export default function Disclosure() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-indigo-600 hover:text-indigo-700 font-semibold">
            ← Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Affiliate Disclosure</h1>

          <div className="prose prose-indigo max-w-none space-y-6 text-gray-700">
            <p className="text-lg">
              BooksForUs participates in affiliate marketing programs. This page explains how we earn commissions and what that means for you.
            </p>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">What Are Affiliate Links?</h2>
              <p>
                Affiliate links are special URLs that allow us to earn a small commission when you purchase products through them.
                These links help support BooksForUs and keep our service free for users.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Amazon Associates Program</h2>
              <p>
                <strong>As an Amazon Associate, we earn from qualifying purchases.</strong>
              </p>
              <p>
                BooksForUs is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program
                designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com.
              </p>
              <p>
                When you click on a book purchase link and buy a book (or anything else) on Amazon, we may receive a small
                commission at no additional cost to you. The price you pay is exactly the same whether you use our affiliate
                link or go directly to Amazon.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Bookshop.org Affiliate Program</h2>
              <p>
                We also participate in the Bookshop.org affiliate program. Bookshop.org is an online bookstore with a mission
                to financially support local, independent bookstores.
              </p>
              <p>
                When you purchase books through our Bookshop.org affiliate links, we earn a commission, and a portion of the
                proceeds supports independent bookstores.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Commitment to You</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>No Extra Cost:</strong> Using our affiliate links never costs you more. You pay the same price as
                  going directly to the retailer.
                </li>
                <li>
                  <strong>Honest Recommendations:</strong> Our affiliate relationships do not influence which books appear in our app.
                </li>
                <li>
                  <strong>Transparency:</strong> We clearly disclose our affiliate relationships through this page and tooltips
                  on our buy buttons.
                </li>
                <li>
                  <strong>Supporting the Service:</strong> Commissions from affiliate purchases help us maintain and improve
                  BooksForUs for book clubs everywhere.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Questions?</h2>
              <p>
                If you have any questions about our affiliate relationships or how we use affiliate links, please feel free
                to contact us.
              </p>
            </section>

            <p className="text-sm text-gray-500 border-t border-gray-200 pt-6 mt-8">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
